import React from 'react';
import '../../../dist/assets/stylesheets/css/recordPatient.css';

/** Read-only summary of set tag values, shown on collapsed headers. */
function TrialTagChips(props) {
    const { items, className, emptyLabel } = props;

    if (!items || !items.length) {
        return emptyLabel ? <span className="trial-tag-chips__empty">{emptyLabel}</span> : null;
    }

    return (
        <span className={className ? `trial-tag-chips ${className}` : 'trial-tag-chips'}>
            {items.map((item) => (
                <span className="trial-tag-chip" key={item.key} title={`${item.label}: ${item.value}`}>
                    {item.value}
                </span>
            ))}
        </span>
    );
}

export default TrialTagChips;
